<h1 mat-dialog-title>{{ data.title }}</h1>
<ng-container [ngComponentOutlet]="data.content"></ng-container>
<div mat-dialog-actions>
  <button
    type="button"
    mat-raised-button
    class="theme-dark-mat-cancel-btn"
    (click)="onCancel()">
    Закрыть
  </button>
</div>
